<div [ngClass]="{'page-container': currentPortal !== PortalType.Normal}">
  <div class="header-container items-end">
    <div class="flex items-end">
      <app-tabs-header [labelText]="'Search persons'"
                       [matTooltip]="'Search for a person by card number, last name or ID number'"
                       [showButton]="false"
                       (valueChanged)="onValueChanged($event)">
      </app-tabs-header>

      <app-product-filter class="ml2"
                          [selectedProducts]="products()"
                          (productChanged)="onProductChanged($event)">
      </app-product-filter>
    </div>

    <div class="header-spacer"></div>

    @if (currentPortal === PortalType.Normal) {
      <button mat-raised-button color="accent"
              (click)="onClickAddPerson()">
        <mat-icon>add</mat-icon>
        Add Person
      </button>
    }
  </div>

  <section class="mat-elevation-z8 table-container">
    <table mat-table multiTemplateDataRows [dataSource]="insuredPersonDataSource"
           matSort (matSortChange)="sortData($event)">

      <ng-container [matColumnDef]="tableColumns.Icons">
        <th *matHeaderCellDef mat-header-cell></th>
        <td *matCellDef="let row" mat-cell>
          <mat-icon *ngIf="hasOnboardingRole" class="table-icon font-medium" matTooltip="EDIT Person"
                    (click)="onClickEditPerson($event, row.insuredPersonId)">
            edit
          </mat-icon>
          <mat-icon *ngIf="hasPermissions"
                    class="table-icon font-medium" matTooltip="DELETE Person"
                    (click)="onClickDeletePerson($event, row.insuredPersonId)">
            delete
          </mat-icon>
          <app-death-status-icon 
          [personId]="row.insuredPersonId" 
          [optionCode]="row.productCode" 
          [membershipNumber]="row.cardNumber">
          </app-death-status-icon>
        </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.CardNumber">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Card Number</th>
        <td *matCellDef="let row" mat-cell>{{row.cardNumber}} </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.NationalIdNumber">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>ID Number</th>
        <td *matCellDef="let row" mat-cell>{{row.nationalIdNumber}} </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.Title">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Title</th>
        <td *matCellDef="let row" mat-cell>{{row?.title?.name}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.Name">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Person Name</th>
        <td *matCellDef="let row" mat-cell>{{getPersonFullName(row) | slice:0:50}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.Association">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Association</th>
        <td *matCellDef="let row" mat-cell>{{row?.association?.name}} </td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.BirthDate">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Birth Date</th>
        <td *matCellDef="let row" mat-cell>{{row?.dateOfBirth | date: dateFormat}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.Gender">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Gender</th>
        <td *matCellDef="let row" mat-cell>{{row.gender?.name}}</td>
      </ng-container>

      <ng-container [matColumnDef]="tableColumns.Product">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Product</th>
        <td *matCellDef="let row" mat-cell>{{row?.productName ?? 'Unknown'}}</td>
      </ng-container>

       <ng-container [matColumnDef]="tableColumns.Status">
        <th *matHeaderCellDef mat-header-cell mat-sort-header> Status</th>
        <td *matCellDef="let row" mat-cell>
          <div class="flex justify-start">
            <greydom-status-indicator
              [fillColor]="getStatusColor(row?.coverStatusName ?? 'unknown')"></greydom-status-indicator>
            <span class="m-l-5">{{ row?.coverStatusName ?? 'Unknown' }}</span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <td *matCellDef="let row" mat-cell [attr.colspan]="insuredPersonDisplayedColumns.length">
          <div class="row-detail-container"
               [@detailExpand]="row == insuredPersonExpandedRow ? 'expanded' : 'collapsed'">
            <b>Title: </b>{{row.title?.name}}<br>
            <b>Designation: </b>{{row?.designation?.name}}<br>
            <b>Marital Status: </b>{{row?.maritalStatus?.name}}<br>
            <b>Country: </b>{{row.country?.name}}<br>
            <b>Associated Person: </b>{{row?.associatedInsuredPerson?.name}}<br>
            <b>Under Disease Management Indicator: </b>{{row.underDiseaseManagementIndicator}}<br>
            <b>Sanction Indicator: </b>{{row.sanctionIndicator}}<br>
            <b>Sanction Reference: </b>{{row.sanctionReference}}<br>
            <b>Sanction Check Date: </b>{{row.sanctionCheckDate | date: dateFormat}}<br>
            <b>CardNumber: </b>{{row.cardNumber}}<br>
            <b>Alternative 1 CardNumber: </b>{{row.alternative1CardNumber}}<br>
            <b>Alternative 2 CardNumber: </b>{{row.alternative2CardNumber}}<br>
            <b>Passport Number: </b>{{row.passportNumber}}<br>
            <b>Created By: </b>{{row.createdBy}}<br>
            <b>Created Date: </b>{{row.created | date: dateTimeFormat}}<br>
            <b>Updated By: </b>{{row.updatedBy}}<br>
            <b>Updated Date: </b>{{row.updated | date: dateTimeFormat}}<br>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="insuredPersonDisplayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: insuredPersonDisplayedColumns;" class="row"
          [class.expanded-row]="insuredPersonExpandedRow == row"
          (click)="insuredPersonExpandedRow = insuredPersonExpandedRow === row ? null : row">
      </tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail'];" class="detail-row"></tr>

    </table>

    <mat-paginator #insuredPersonPaginator (page)="pageChanged($event)"
                   [length]="insuredPersonTableControl.length" [pageSize]="insuredPersonTableControl.pageSize" [pageIndex]="0"
                   [pageSizeOptions]="insuredPersonTableControl.pageSizeOptions">
    </mat-paginator>

  </section>
</div>
